export default {"src":"/_next/static/media/cheers_24.3f5cb924.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};